import { styled } from '@mui/material';
import HtmlTooltip from '../../components/html-tooltip/HtmlToolTip.styles';

const PREFIX = 'ReferencesValueViewer';

export const classes = {
  icon: `${PREFIX}-icon`,
};

export const StyledHtmlTooltip = styled(HtmlTooltip)(({ theme }) => ({
  [`& .${classes.icon}`]: {
    color: theme.palette.info.main,
    fontSize: '1.25em',
    width: '20px',
    marginLeft: theme.spacing(1),
  },
}));

